import { useMutation } from '@tanstack/react-query';

import { apiFetch } from '@/domains/general/api/client';

import type { ChatRequest, ChatResponse } from './types';

export function useSendChat() {
  return useMutation({
    mutationFn: (body: ChatRequest) =>
      apiFetch<ChatResponse>('/chat', {
        method: 'POST',
        body: JSON.stringify(body),
      }),
  });
}
